import _ from 'lodash';
import i18n from "../../../shared/i18n";
import {store} from './../../../plugins/vuex/index'
import RelationsService from "@/modules/relations/RelationsService";
import {RELATIONS_TABLE_NAME} from "@/modules/constants";
import RelationSearchModel from "@/modules/relations/RelationsSearch.model";
import cloneDeep from "lodash/cloneDeep";

let getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
    search: '',
    searchModel: new RelationSearchModel(),
    object: {},
    extraFilters: {},
    extraExpands: '',
    expand: '',
    toggleColumns: {
      fields: [...getDefaultFields(), ...differentFields],
      requiredFields: ['type'],
      defaultFields: ['type', 'created_at', 'updated_at', 'related_customer_uuid']
    }
  }
};

let getDefaultFields = () => {
  return [
    {
      key: "type",
      label: i18n.t('Type'),
      sortable: true,
      tdClass: 'type-col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'related_customer_uuid',
      label: i18n.t('Related Customer'),
      sortable: true,
      tdClass: 'related-customer-col',
      isVisible: true,
      expand: 'related_customer'
    },
    {
      key: 'related_to_customer_uuid',
      label: i18n.t('Related to Customer'),
      sortable: true,
      tdClass: 'related-to-customer-col',
      isVisible: false,
      expand: 'related_customer'
    },
    {
      key: 'related_to_receipt_uuid',
      label: i18n.t('Related to Receipt'),
      sortable: true,
      tdClass: 'related-to-receipt-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'created_at',
      label: i18n.t('Created at / Created by'),
      sortable: true,
      tdClass: 'created-at-col',
      isVisible: true,
      expand: 'created_by'
    },
    {
      key: 'updated_at',
      label: i18n.t('Updated at / Updated by'),
      sortable: true,
      tdClass: 'updated-at-col',
      isVisible: true,
      expand: 'updated_by'
    },
    {
      key: 'note',
      label: i18n.t('Note'),
      sortable: true,
      tdClass: 'note-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'intermediary_commission_rate',
      label: i18n.t('Intermediary Commission Rate'),
      sortable: true,
      tdClass: 'intermediary_commission_rate-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'intermediary_flat_price',
      label: i18n.t('Intermediary Flat Price'),
      sortable: true,
      tdClass: 'intermediary_flat_price-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'intermediary_commission_from',
      label: i18n.t('Calculate From'),
      sortable: true,
      tdClass: 'intermediary_commission_from-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'including_vat',
      label: i18n.t('Including Vat'),
      sortable: true,
      tdClass: 'including_vat-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'hidden',
      label: i18n.t('Hidden'),
      sortable: true,
      tdClass: 'hidden-col',
      isVisible: false,
      expand: ''
    },
  ]
}

export default {
  namespaced: true,
  state: {
    tableSource: null,
    tableData: {
      customer: getDefaultTableData(),
      customerRelatedTo: getDefaultTableData(),
      receipt: getDefaultTableData(),
    },
    modal: {
      show: false,
      object: null,
      sourceObject: null,
      source: null
    },
  },
  actions: {
    resetSearchModel({commit}) {
      commit('resetSearchModel')
    },
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new RelationSearchModel({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: `${RELATIONS_TABLE_NAME}.${state.tableSource}`
      });

      if (payload) {
        data = {
          ...payload.pagination,
          search: payload.search,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...currentTableData.pagination,
          search: currentTableData.search,
          ordering: ordering,
        }
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      const expands = state.tableData[state.tableSource].extraExpands;
      const defaultExpand = currentTableData.expand;
      const expand = currentTableData.toggleColumns.fields
        .filter(c => currentTableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
        .map(c => c.expand)
        .join(',')

      data.expand = [expand, defaultExpand, expands].join(',');

      return data;
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await RelationsService.getRelations(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }

      return response;
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      const object = state.tableData[state.tableSource].object;
      const extraExpands = state.tableData[state.tableSource].extraExpands;
      const tmpToggleColumns = _.cloneDeep(state.tableData[state.tableSource].toggleColumns);
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].extraFilters = extraFilters;
      state.tableData[state.tableSource].object = object;
      state.tableData[state.tableSource].extraExpands = extraExpands;
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      dispatch('getTableData');
    },
    async updateTableSource({state}, {extraFilters, source, object, extraExpands}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
      state.tableData[source].extraExpands = extraExpands;
      state.tableData[source].object = cloneDeep(object);
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
    showModal({commit}, {object = {}, source, sourceObject} = {}) {
      commit('showModal', {object: _.cloneDeep(object), source, sourceObject});
    },
    hideModal({commit}) {
      commit('hideModal');
    },
    async removeRelation({dispatch}, payload) {
      let response = await RelationsService.removeRelation(payload.uuid)
      if (response.success) {
        dispatch('getTableData')
      }
      return response;
    }
  },
  mutations: {
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {...state.tableData[state.tableSource], ...payload},
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData[state.tableSource].toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData[state.tableSource].toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData[state.tableSource].toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData[state.tableSource].toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
    resetSearchModel: state => {
      state.tableData[state.tableSource].searchModel = new RelationSearchModel()
    },
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    showModal: (state, {object, source, sourceObject}) => {
      state.modal.show = true;
      state.modal.object = object;
      state.modal.source = source;
      state.modal.sourceObject = sourceObject;
    },
    hideModal: state => {
      state.modal.show = false;
      state.modal.object = null;
      state.modal.source = null;
      state.modal.sourceObject = null;
    },
  }
}
